import { lazy } from 'react';
import { Permission, type SkillManifest } from '@brandschutz/shared';
import type { FrontendSkill } from '../_core/registry';

/**
 * Schlanker Skill-Descriptor für das Bootstrap — Slot-Renderer ist React.lazy,
 * sodass die Sidebar-Box erst lädt, wenn der Slot im Project-Detail rendert.
 */
const manifest: SkillManifest = {
  key: 'collaboration-assignments',
  name: 'Projektbesetzung',
  description:
    'Verantwortlichen (genau einer) und Vertreter (optional, mehrere) einem Projekt zuordnen — füllt die Sidebar im Project-Detail.',
  category: 'collaboration',
  version: '0.1.0',
  requiredPermissions: [Permission.PROJECT_READ],
  enabledByDefault: true,
};

const AssignmentsBox = lazy(() =>
  import('./AssignmentsBox').then((m) => ({ default: m.AssignmentsBox })),
);

export const collaborationAssignmentsSkill: FrontendSkill = {
  manifest,
  slots: {
    'project-detail.sidebar': [
      {
        key: 'assignments-box',
        // Block „Wer" der Projekt-Sidebar (order ≤ 30, s. ProjectDetailPage):
        // Wer verantwortlich ist, steht ganz oben.
        order: 10,
        // @ts-expect-error Slot context shape ist dynamic — Caller liefert projectId+readOnly
        render: AssignmentsBox,
      },
    ],
  },
};
